import React, { useState } from 'react'
import * as Yup from 'yup'
import { Formik } from 'formik'
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    makeStyles
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import Page from '../../components/Page'
import firebase from 'firebase/app'

import 'firebase/auth'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        height: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}))

const ForgotPasswordView = () => {
    const classes = useStyles()
    // const navigate = useNavigate();
    const [formValidateMessage, setformValidateMessage] = useState()
    // const [value, setValue] = useState({
    //   email: 'demo@devias.io',
    //   password: 'Password123'
    // });

    return (
        <Page className={classes.root} title="Login">
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    {formValidateMessage ? (
                        <Box mb={3}>
                            <Alert
                                severity={
                                    formValidateMessage.type === 'error'
                                        ? 'error'
                                        : 'success'
                                }
                                onClose={() => formValidateMessage(null)}
                            >
                                <AlertTitle>
                                    {formValidateMessage.type === 'error'
                                        ? 'Error'
                                        : 'Message Sent'}
                                </AlertTitle>
                                {formValidateMessage.message}
                            </Alert>
                        </Box>
                    ) : null}
                    <Formik
                        initialValues={{ email: '' }}
                        validationSchema={Yup.object().shape({
                            email: Yup.string()
                                .email('Must be a valid email')
                                .max(255)
                                .required('Email is required')
                        })}
                        onSubmit={async (values) => {
                            await firebase
                                .auth()
                                .sendPasswordResetEmail(values.email)
                                .then(() => {
                                    // Signed in
                                    // var user = userCredential.user;
                                    // ...
                                    // navigate('/app/dashboard', { replace: true });
                                    setformValidateMessage({
                                        type: 'success',
                                        message:
                                            'Password reset email sent successfully. Please check your email, follow instuctions. If you need further help, contact with you developer team.'
                                    })
                                })
                                .catch((error) => {
                                    setformValidateMessage({
                                        type: 'error',
                                        message: error.message
                                    })
                                    // var errorCode = error.code;
                                    // var errorMessage = error.message;
                                    // ..
                                    console.log(error)
                                })
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mb={3}>
                                    <Typography
                                        color="textPrimary"
                                        variant="h2"
                                    >
                                        Forgot Password ?
                                    </Typography>
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        variant="body2"
                                    >
                                        Enter your email for to get password
                                        reset email
                                    </Typography>
                                </Box>

                                <TextField
                                    error={Boolean(
                                        touched.email && errors.email
                                    )}
                                    fullWidth
                                    helperText={touched.email && errors.email}
                                    label="Email Address"
                                    margin="normal"
                                    name="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="email"
                                    value={values.email}
                                    variant="outlined"
                                />
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Box>
        </Page>
    )
}

export default ForgotPasswordView
